import React from 'react';
import 'swiper/swiper-bundle.css';
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './Carrousel.css';

// Install Swiper modules
SwiperCore.use([Navigation, Pagination, A11y]);

const Carrousel = ({
  items = [],
  style = {},
  children,
  spaceBetween = 0,
  slidesPerView = 1,
  className = 'collection-swiper',
  pagination = { clickable: true },
}) => {
  return (
    <Swiper
      spaceBetween={spaceBetween}
      slidesPerView={slidesPerView}
      navigation
      pagination={pagination}
      loop={true}
      className={className}
      style={style}
    >
      {items.map((item, index) => (
        <SwiperSlide key={index}>{children(item, index)}</SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Carrousel;
